import dayjs from 'dayjs'
import { getPercentage } from 'src/consumer/helpers/utilFunctions'
import { ReportsSubTableContainer, ReportsTableItem } from '../../styledComponents'
import {
  getPercentageStringInBrackets,
  getValidIntegerOrNaForClinicReport,
} from '../OverallReportComponent'

export default function BrandPatientVisitReport({
  metricData,
  reportEndTime,
  reportStartTime,
  getCorrectReportDateString,
  allClinicLocations,
  showPaymentRelatedData,
}) {
  const allColumnsLength = (showPaymentRelatedData ? 4 : 3) + (allClinicLocations?.length || 0)

  return (
    <ReportsTableItem columns={allColumnsLength}>
      <div className="reports-top-header">
        {reportEndTime &&
          getCorrectReportDateString(
            dayjs.utc(reportEndTime).local(),
            dayjs.utc(reportStartTime).local(),
          )}
      </div>
      <ReportsSubTableContainer className="report-item px-0" columns={3}>
        <div className="fw-bold break-word-class report-sub-item">New</div>
        <div className="fw-bold break-word-class report-sub-item">Repeat</div>
        <div className="fw-bold break-word-class report-sub-item">Total</div>
        {/* {showPaymentRelatedData && (
          <div className="fw-bold break-word-class report-sub-item">Fee Collected</div>
        )} */}
      </ReportsSubTableContainer>
      <ReportsSubTableContainer className="report-item px-0" columns={3}>
        <div className="report-sub-item">
          {getValidIntegerOrNaForClinicReport(metricData?.newBookedCount)}{' '}
          {getPercentageStringInBrackets(
            getPercentage(metricData?.newBookedCount, metricData?.totalBookedCount, 0),
          )}
        </div>
        <div className="break-word-class report-sub-item">
          {getValidIntegerOrNaForClinicReport(metricData?.repeatBookedCount)}{' '}
          {getPercentageStringInBrackets(
            getPercentage(metricData?.repeatBookedCount, metricData?.totalBookedCount, 0),
          )}
        </div>
        <div className="break-word-class fw-bold report-sub-item">
          {getValidIntegerOrNaForClinicReport(metricData?.totalBookedCount)}{' '}
          {getPercentageStringInBrackets(
            getPercentage(metricData?.totalBookedCount, metricData?.totalBookedCount, 0),
          )}
        </div>
        {/* {showPaymentRelatedData && (
          <div className="break-word-class report-sub-item">
            {getFeeRelatedStringForClinicReport(metricData?.currencyToFeeCollectedMap)}
          </div>
        )} */}
      </ReportsSubTableContainer>
      {allClinicLocations?.map((clnLoc) => (
        <ReportsSubTableContainer
          key={`patient-rep-${clnLoc?.id}`}
          className="report-item px-0"
          columns={3}
        >
            <div className="break-word-class report-sub-item">
              {getValidIntegerOrNaForClinicReport(metricData?.[`${clnLoc?.id}__newBookedCount`])}{' '}
              {getPercentageStringInBrackets(
                getPercentage(
                  metricData?.[`${clnLoc?.id}__newBookedCount`],
                  metricData?.[`${clnLoc?.id}__totalBookedCount`],
                  0,
                ),
              )}
            </div>
            <div className="break-word-class report-sub-item">
              {getValidIntegerOrNaForClinicReport(metricData?.[`${clnLoc?.id}__repeatBookedCount`])}{' '}
              {getPercentageStringInBrackets(
                getPercentage(
                  metricData?.[`${clnLoc?.id}__repeatBookedCount`],
                  metricData?.[`${clnLoc?.id}__totalBookedCount`],
                  0,
                ),
              )}
            </div>
            <div className="break-word-class fw-bold report-sub-item">
              {getValidIntegerOrNaForClinicReport(metricData?.[`${clnLoc?.id}__totalBookedCount`])}{' '}
              {getPercentageStringInBrackets(
                getPercentage(
                  metricData?.[`${clnLoc?.id}__totalBookedCount`],
                  metricData?.[`${clnLoc?.id}__totalBookedCount`],
                  0,
                ),
              )}
            </div>
          </ReportsSubTableContainer>
      ))}
    </ReportsTableItem>
  )
}
